import React from 'react';
import { StatusBanca, BancaUtils } from '../../../model/banca/Banca';

interface StatusBancaButtonProps {
  status: StatusBanca;
  onClick: () => void;
}

const StatusBancaButton: React.FC<StatusBancaButtonProps> = ({ status, onClick }) => {
  return (
    <button
      style={{
        backgroundColor: BancaUtils.getStatusColor(status),
        color: 'black',
        border: '1px solid #ccc',
        borderRadius: '3px',
        padding: '4px 8px',
        fontSize: '12px',
        cursor: 'pointer',
        fontWeight: '500'
      }}
      onClick={onClick}
      title={BancaUtils.getStatusBancaString(status)}
    >
      {BancaUtils.getStatusBancaString(status).replace('Banca ', '')}
    </button>
  );
};

export default StatusBancaButton;